import React from 'react'
import { MEDIA_BUCKET } from 'config'
import TickImage from 'assets/images/play/tick.svg'

const PlayStepProgressStepper = ({
  steps,
  setUpStepId,
  changeSetUpStepHandler,
  disabled,
  currentActiveStep,
}) => {
  const getImage = (step, idx) => {
    const isCompleted = step?.isCompleted || currentActiveStep?.steps[idx]?.isCompleted
    const icon = step?.stepIcon

    if (isCompleted) {
      return <CompletedPlayImg />
    } else if (icon) {
      return (
        <img
          src={MEDIA_BUCKET + icon}
          alt="step icon"
          className="stepIcon w-[50px] h-[50px] p-[10px]"
        />
      )
    } else {
      return <div id="icon-fallback-content" className="bg-primary h-[46px] w-[46px] fill-white" />
    }
  }

  return (
    <div className="stepsInnerContent">
      <div className="relative flex flex-col gap-[20px]">
        {steps?.map((step, index) => {
          return (
            <div
              className="flex items-center gap-[20px] cursor-pointer group"
              key={index}
              onClick={() => changeSetUpStepHandler(step?.id)}
            >
              <div
                className={[
                  'w-[50px] h-[50px] rounded-full flex items-center flex-shrink-0 border-2 border-grey',
                  !disabled && setUpStepId === step.id ? 'bg-tertiary' : 'bg-grey-lighter3x',
                ].join(' ')}
              >
                {getImage(step, index)}
              </div>
              <div
                className={[
                  setUpStepId === step.id
                    ? 'font-semibold text-tertiary'
                    : 'group-hover:text-primary',
                  'font-primary text-sm text-black-light cursor-pointer',
                ].join(' ')}
              >
                {step.stepTitle}
              </div>
            </div>
          )
        })}

        <div className="stepsMidLine"></div>
      </div>
    </div>
  )
}

const CompletedPlayImg = () => (
  <img src={TickImage} alt="tick" className="w-[50px] h-[50px] p-[10px]" />
)

export default PlayStepProgressStepper
